import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseDialog from "../ui/BaseDialog";
import ActionButton from "../ui/ActionButton";

// modal to confirm deletion of one or more listings
const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  count,
  darkMode,
  isDeleting = false,
}) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={count === 1 ? t("Delete Listing") : t("Delete Listings")}
      darkMode={darkMode}
      ariaLabelledBy="delete-confirm-modal-title"
      ariaDescribedBy="delete-confirm-modal-description"
      actions={
        <>
          <ActionButton
            onClick={onClose}
            variant="default"
            modal
            disabled={isDeleting}
          >
            {t("Cancel")}
          </ActionButton>
          <ActionButton
            onClick={onConfirm}
            variant="danger"
            modal
            loading={isDeleting}
          >
            {t("Delete")}
          </ActionButton>
        </>
      }
    >
      {/* message */}
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "1rem",
          color: darkMode ? "#e0e0e0" : "#666666",
          textAlign: "center",
        }}
      >
        {count === 1
          ? t(
              "Are you sure you want to delete this listing? This action cannot be undone."
            )
          : t(
              "Are you sure you want to delete these {{count}} listings? This action cannot be undone.",
              { count }
            )}
      </Typography>
    </BaseDialog>
  );
};

DeleteConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  darkMode: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool,
};

export default DeleteConfirmModal;
